document.addEventListener('alpine:init', () => {
  Alpine.data('collection', () => ({
    alpineReady: false,
    search: '',
    species: [],
    industries: [],
    regions: [],
    patterns: [],
    filters: {
      product_name: '',
    },
    records: window.projectList || [],
    itemsPerPage: 9,
    currentPage: 0,
    num: 0,
    isOpen: false,
    currentIndex: 0,

    formatFilterValue(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    getFilterTokens(value) {
      if (typeof value !== 'string') return [];

      return value
        .split('|')
        .map((token) => token.trim())
        .filter(Boolean);
    },
    buildFilterOptions(field) {
      return [
        ...new Set(
          this.records.flatMap((record) =>
            this.getFilterTokens(record[field]).map((value) => this.formatFilterValue(value)),
          ),
        ),
      ].sort();
    },

    openModal(index, event) {
      this.triggerEl = event?.currentTarget || document.activeElement;
      this.currentIndex = index;
      this.isOpen = true;
      const slug = this.page?.[index]?.project_slug;
      if (slug) {
        const url = new URL(window.location.href);
        url.searchParams.set('project', slug);
        history.pushState({}, '', url);
      }

      document.body.style.overflow = 'hidden';
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }

      this.$nextTick(() => {
        this.swiperInstance = new Swiper('.modal-gallery', {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          loop: true,
        });
        trapFocus(this.$refs.modalContent, this.$refs.modalClose);
      });
    },
    closeModal() {
      if (!this.isOpen) return;
      this.isOpen = false;
      removeTrapFocus(this.triggerEl);
      document.body.style.overflow = '';
      const url = new URL(window.location.href);
      url.searchParams.delete('project');
      history.pushState({}, '', url);
    },
    cleanDescription() {
      return this.project_description.replace(/[^\w\s]/gi, ''); // Removes special characters
    },
    numOfPages() {
      const total = Math.ceil(this.filteredRecords.length / this.itemsPerPage);
      this.num = total - 1;
      return total;
    },
    get page() {
      return this.filteredRecords.slice(
        this.currentPage * this.itemsPerPage,
        (this.currentPage + 1) * this.itemsPerPage,
      );
    },
    async getRecords() {
      this.records.sort((a, b) => Number(b.project_order) - Number(a.project_order));

      this.species = this.buildFilterOptions('project_species');
      this.industries = this.buildFilterOptions('project_industry');
      this.regions = this.buildFilterOptions('project_region');
      this.patterns = this.buildFilterOptions('project_pattern');
      document.documentElement.classList.add('alpine');
    },
    get currentRecord() {
      return this.page?.[this.currentIndex] || null;
    },
    get filteredRecords() {
      let filtered = this.records.filter((item) => {
        for (let key in this.filters) {
          const value = this.filters[key];
          if (value === '' || value === 'all') continue;

          const itemValues = this.getFilterTokens(item[key]).map((token) => this.formatFilterValue(token));
          if (!itemValues.includes(value)) return false;
        }
        return true;
      });
      return filtered;
    },
    openModalBySlug(slug) {
      const index = this.filteredRecords.findIndex((r) => r.project_slug === slug);
      if (index !== -1) {
        this.currentPage = Math.floor(index / this.itemsPerPage);

        this.$nextTick(() => {
          this.openModal(index % this.itemsPerPage);
        });
      }
    },

    groupColors(project_colors) {
      const colorsByHandle = {};
      if (!project_colors) return colorsByHandle;

      project_colors.split('|').forEach((entry) => {
        const [handle, variantId] = entry.split(':');
        if (!colorsByHandle[handle]) {
          colorsByHandle[handle] = [];
        }
        colorsByHandle[handle].push(variantId);
      });

      return colorsByHandle;
    },
    groupByHandle(colorsArray) {
      const grouped = {};
      if (!Array.isArray(colorsArray)) return grouped;
      colorsArray.forEach((entry) => {
        if (!grouped[entry.handle]) grouped[entry.handle] = [];
        grouped[entry.handle].push(entry);
      });
      return grouped;
    },
    message() {
      return `${this.filteredRecords.length} records`;
    },
    init() {
      this.getRecords();

      this.$nextTick(() => {
        this.alpineReady = true;
        const params = new URLSearchParams(window.location.search);
        const slug = params.get('project');
        if (slug) {
          this.openModalBySlug(slug);
        }
      });
      this.$watch('filters', (filter) => (this.currentPage = 0));
    },
  }));
});
